<template>
  <base-section
    id="features"
    class="secondary"
  >
    <v-responsive
      class="mx-auto"
      max-width="1350"
    >
      <v-container fluid>
        <v-row>
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="4"
            md="3"
          >
            <base-info-card
              align="center"
              dark
              v-bind="card"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionFeatures',

    data: () => ({
      cards: [
        {
          // icon: 'mdi-anvil',
          icon: 'mdi-cards-spade',
          title: 'Experiencia',
          text: ' Más de 15 años de experiencia en el sector, nuestros clientes nos avalan.',
        },
        {
          icon: 'mdi-cards-heart',
          title: 'Profesionalidad',
          text: 'Velamos por la calidad del servicio prestado.',
        },
        /* {
          // icon: 'mdi-alarm',
          icon: 'mdi-cards-diamond',
          title: 'Compromiso',
          text: 'Su satisfacción es nuestra prioridad.',
        }, */
        {
          // icon: 'mdi-bike-fast',
          icon: 'mdi-cards-diamond',
          title: 'Eficiencia',
          text: 'Alta productividad con los recursos mínimos y adecuados. Certificado de gestión ISO 9001.',
        },
        {
          // icon: 'mdi-bike-fast',
          icon: 'mdi-cards-club',
          title: 'Medio Ambiente',
          text: 'Nuestros servicios llevan el sello de gestión medioambiental . Certificado ISO 14001.',
        },
      ],
    }),
  }
</script>
